import { Heading, Stack, ModalContent, ModalCloseButton } from '@chakra-ui/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { ControllableModal } from 'components/Modal';

interface IUpdateSeriesConfirmationModal {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  handleYesClick: () => void;
  handleNoClick: () => void;
}

const UpdateSeriesConfirmationModal: React.FC<IUpdateSeriesConfirmationModal> = ({
  isOpen,
  onClose,
  title,
  handleNoClick,
  handleYesClick,
}) => {
  const { t } = useTranslation(['common', 'scheduling']);

  return (
    <ControllableModal isOpen={isOpen} onClose={onClose}>
      <ModalContent p="6" pt="10" textAlign="center">
        <ModalCloseButton />
        <Heading as="h6" size="md" mb="2">
          {title}
        </Heading>
        <Stack direction="row" justifyContent="center" mt="6">
          <Button width="170px" onClick={handleYesClick}>
            {t('common:yes')}
          </Button>
          <Button width="170px" variant="outline" fontWeight="semibold" onClick={handleNoClick}>
            {t('common:no')}
          </Button>
        </Stack>
      </ModalContent>
    </ControllableModal>
  );
};

export default memo(UpdateSeriesConfirmationModal);
